import type { Review } from '@baseball-near-you/prisma';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { clients } from '../clients';
import { QueryKey } from '../hooks/QueryKey';

export function useReviewTeamMutation(
  teamId: number,
  options?: {
    hideToast?: boolean;
  }
) {
  const queryClient = useQueryClient();
  const {
    mutateAsync: reviewTeam,
    isLoading: isReviewingTeam,
    error: reviewTeamError,
  } = useMutation({
    mutationFn: async (data: Partial<Review>) => {
      return await clients.team.addReview({
        args: { teamId: teamId! },
        payload: data,
      });
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries([QueryKey.Team, teamId, 'reviews']);
      await queryClient.invalidateQueries([QueryKey.User]);
      if (!options?.hideToast) {
        toast.success('You have successfully submitted your review!');
      }
    },
  });

  return {
    reviewTeam,
    isReviewingTeam,
    reviewTeamError,
  };
}
